import { Component, OnInit } from '@angular/core';
import { HeadingComponent } from './heading.component';

@Component({
  selector: 'subsubheading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss']
})
export class SubSubheadingComponent extends HeadingComponent {
  level: number = 2;
  
   constructor() { 
      super();
   }
  

}
